// Content of the Table view's per-row expand panel (DateCell's chevron
// toggle). Renders Table-only cards (TableFoodLogPanel / TableMealPhotosPanel
// — see those files for why they don't reuse the shared calendar log-cards
// directly). DateCell only makes a day clickable when
// `day.photos > 0 || day.hasFoodLog`, so at least one of the two below
// always has something to render once this panel mounts.
import PropTypes from "prop-types";

import TableFoodLogPanel from "./TableFoodLogPanel";
import TableMealPhotosPanel from "./TableMealPhotosPanel";

const hasFoodLogMeals = (stat) =>
  Boolean(stat?.foodLog?.meals?.length || stat?.internalFoodLog?.meals?.length);
const hasMealPhotos = (stat) =>
  Object.values(stat?.mealPhotos ?? {}).some((meal) => (meal?.list?.length ?? 0) > 0);

const TableDetailPanel = ({ stat, utcDate, locals }) => {
  if (!stat) return null;
  const showFoodLog = hasFoodLogMeals(stat);
  const showMealPhotos = hasMealPhotos(stat);
  if (!showFoodLog && !showMealPhotos) return null;

  return (
    <div className="np-table-detail-panel">
      {showFoodLog && <TableFoodLogPanel stat={stat} />}
      {showMealPhotos && <TableMealPhotosPanel stat={stat} utcDate={utcDate} locals={locals} />}
    </div>
  );
};

TableDetailPanel.propTypes = {
  stat: PropTypes.object,
  utcDate: PropTypes.number,
  locals: PropTypes.object,
};

export default TableDetailPanel;
